<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import {
    getType
  } from '@/assets/js/pcMobile.js'
  export default {
    name: 'App',
    data() {
      return {
        screenWidth: document.body.clientWidth
      }
    },
    computed: {},
    mounted() {
      const that = this
      window.onresize = () => {
        return (() => {
          window.screenWidth = document.body.clientWidth
          that.screenWidth = window.screenWidth
        })()
      }
    },
    watch: {
      screenWidth(newValue, oldValue) {
        let flag = getType()
        if (flag == 'pc') {
          this.$router.go(0)
        }
      }
    },
  }
</script>

<style lang="scss">
  body,
  p,
  ul,
  li {
    margin: 0;
    padding: 0;
  }

  ul,
  li {
    list-style: none
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
  }


  // 公共盒子
  .main {
    width: 100%;

    &-inner {
      width: 14.4rem;
      height: 100%;
      margin: auto;
    }
  }

  .ref {
    position: relative;
  }

  .disfx {
    display: flex;
    justify-content: center;
  }

  .fx1 {
    flex: 1;
  }

  .fx1 {
    flex: 2;
  }

  // PC端 PACKAGE CONTENTS
  .packgae {
    background-color: #f7f7f7;
    padding: 1rem 0 0.3rem;

    .packgaes {
      &-title {
        font-size: 0.38rem;
        color: #858266;
      }

      &-info {
        margin-top: .6rem;

        &-list {
          margin-bottom: 0.3rem;

          .setitle {
            border-left: 0.04rem #606060 solid;
            display: inline-block;
            padding: 0 0.1rem;
            font-size: 0.28rem;
            color: #606060;
          }

          .devinfo {
            padding-left: 1.9rem;
            position: relative;
            height: 1.9rem;

            &-img {
              width: 1.6rem;
              height: 1.6rem;
              position: absolute;
              left: 0;
              top: 0;
            }

            &-font {
              font-size: 0.24rem;
              color: #313131;
              line-height: 0.30rem;

              &-title {
                padding-top: 0.3rem;

                span {
                  font-size: 0.36rem;
                }
              }

              &-name {
                padding: 0.1rem 0;
              }

              &-other {}
            }
          }
        }
      }
    }

  }

  // mobile端 PACKAGE CONTENTS
  .mpackgae {
    background-color: #f7f7f7;
    padding: 0.4rem 0;
    overflow: hidden;
    &-title {
      font-size: 0.36rem;
      color: #858266;
      text-align: center;
    }

    &-info {
      padding: .2rem 0.4rem 0;

      &-tit {
        border-left: 0.04rem #606060 solid;
        padding-left: 0.2rem;
        margin-bottom: 0.2rem;
        font-size: 0.3rem;
        color: #606060;
      }

      &-list {
        margin-bottom: 0.4rem;
        .mdevinfo {
          &-img {
            width: 60%;
          }

          &-font {
            font-size: 0.26rem;
            color: #313131;
            line-height: 0.36rem;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue